<template>
  <b-container fluid>
    <b-row class="mb-1">
      <b-col cols="12">
        <h2>Organization: {{request.businessName}}</h2>

        <b-table-simple hover small caption-top responsive>
          <b-tbody>
            <b-tr v-if="request.dhsCertificationNumber">
              <b-th>DCYF certification number:</b-th>
              <b-td>
                <span>{{ request.dhsCertificationNumber }}</span>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Address:</b-th>
              <b-td>
                <span>{{ request.address }}</span>
                <span>
                  <br/>
                  {{ request.city }}, {{ request.state }} {{ request.zipCode }}
                </span>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>Primary contact:</b-th>
              <b-td>
                <span>{{ request.firstName }} {{ request.lastName }}</span>
                <span>
                  <br/>
                  {{ request.emailAddress }}
                </span>
                <span>
                  <br/>
                  {{ request.phoneNumber }}
                </span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>        
      </b-col>
    </b-row>

    <div class="card mb-3">
      <strong class="card-header">Action</strong>
      <div class="card-body">
        <b-row>
          <b-col cols="12">
            <label for="status"><strong>Request status:</strong></label><br/>
            <b-form-select id="status" :state="null" :options="options" v-model="request.requestStatus"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="12">
            <b-button variant="primary" @click="updateRequest" role="button">Save</b-button>
            <b-button @click="close" role="button">Close</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>

import { commonOptions } from '@/mixins/commonOptions.js'
import axios from 'axios'
export default {

  mixins: [
       commonOptions
  ],

  data: () => ({
    options: [
      { value: 'PENDING', text: 'PENDING' },
      { value: 'DENIED', text: 'DENIED' },
      { value: 'APPROVED', text: 'APPROVED' }
    ],
    orgRequest: {
      organizationType: 'Employer',
      organizationId: null,
      businessName: null,
    },
    orgOptions: [],
    orgTypeOptions: [
      'Employer',
      'Childcare Center'
    ]
  }),

  props: {
    request: Object,
    type: String
  },

  methods: {
    close() {
      this.$bvModal.hide('modal-crud')
    },

    updateRequest() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/isDuplicate/${this.request.emailAddress.toLowerCase().trim()}`)
        .then(response => {
          if (response.data === false || this.request.requestStatus === 'DENIED' || this.type === 'Facility') {   // Reject duplicate emails but allow request to be denied or ignore if a facility request
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/update`, this.request)
              .then(response => {
                this.showRootToast("Success", "Request has been updated.", "success");
                this.$bvModal.hide('modal-crud');
                this.$emit('refresh-list', true);
              })
          } else {
            this.showRootToast('Error', 'An account is already registered with this email.', 'danger')
          }
        })
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })
    },
  },

}
</script>

<style>
  .fieldHeader { 
    background-color: silver;
  }
</style>
